import { ButtonSizeType } from '../types';
import { ButtonSizeProp } from '../properties';

export function getButtonSize(size?: ButtonSizeType) {
  if (!size) return '';

  return ButtonSizeProp[size];
}
